import { Unit, UnitBaseTypes } from "../../Units";

function Inch() {
  return (
    <>
      <Unit unit={UnitBaseTypes.inch} />
    </>
  );
}

export default Inch;
